import { Injectable } from '@angular/core';
import { Slugger } from '../api/slug/slug-models';
import { UserRole, UserSircle, UserStorage } from './local-storage.model';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  private getUserStorage(): UserStorage {
    return JSON.parse(localStorage.getItem('user'));
  }

  public getUser(): UserStorage {
    const USER = this.getUserStorage();
    return USER;
  }

  public getUserSircles(): UserSircle[] {
    const USER = this.getUserStorage();
    return USER.menu;
  }

  public getUserRoles(sircleId: number): UserRole[] {
    const USER = this.getUserStorage();
    const SIRCLE = USER.menu.find((e) => e.id === sircleId);
    return SIRCLE.roles;
  }

  public setUser(user: UserStorage) {
    localStorage.setItem('user', JSON.stringify(user));
  }

  public getUserCoreMemberOf() {
    const USER = this.getUserStorage();
    return USER.isCoreMemberOf;
  }

  public setUserAvatar(avatarUri: string) {
    const USER = this.getUserStorage();
    USER.avatar = avatarUri;
    this.setUser(USER);
  }

  public checkIfLeader(sircleId: number): boolean {
    const USER = this.getUserStorage();
    const sircle = USER.menu.find((sircle) => sircle.id == sircleId);
    if (!sircle) {
      return false;
    }
    return sircle.isLeader;
  }

  public setSlugger(slugger: Slugger): void {
    localStorage.setItem('slugger', JSON.stringify(slugger));
  }

  public getSlugger(): Slugger {
    return JSON.parse(localStorage.getItem('slugger'));
  }
}
